import { LOGGED_IN,
  LOGGED_OUT,
  RESTORED_LOGGED_IN,
  RESTORED_LOGGED_OUT } from 'src/services/session/actions';

import { getCurrentUserId, identifyFromUser } from 'src/lib/analytics';
import integration from 'src/lib/api/integration';
import pd from 'src/lib/api/pagerduty';
import { setPagerDutyAccountMetadataForBugsnag } from 'src/lib/bugsnag';
import { getEnvironment } from 'src/lib/featureFlags';

const middleware = store => next => action => {
  switch (action.type) {
    case RESTORED_LOGGED_IN:
    case LOGGED_IN:
      configureLoggedInUser(action);
      break;

    case RESTORED_LOGGED_OUT:
    case LOGGED_OUT:
      pd.configure({
        accessToken: null,
        apiBaseUrl: getEnvironment().apiBaseUrl,
        appBaseUrl: getEnvironment().appBaseUrl,
      });

      integration.configure({
        accessToken: null,
        accountBaseUrl: getEnvironment().accountBaseUrl,
        apiBaseUrl: getEnvironment().apiBaseUrl,
        appBaseUrl: getEnvironment().appBaseUrl,
      });

      setPagerDutyAccountMetadataForBugsnag({ accountDomain: null });
      break;

    default:
      break;
  }

  return next(action);
};

const configureLoggedInUser = (action) => {
  pd.configure({
    accessToken: action.accessToken,
    apiBaseUrl: action.apiBaseUrl,
    appBaseUrl: action.appBaseUrl,
    accountDomain: action.accountDomain
  });

  integration.configure({
    accessToken: action.accessToken,
    accountBaseUrl: action.environment.accountBaseUrl,
    apiBaseUrl: action.environment.apiBaseUrl,
    appBaseUrl: action.environment.appBaseUrl
  });

  setPagerDutyAccountMetadataForBugsnag({
    accountDomain: action.accountDomain
  });
  //Always identify the user for new logins, only identify for restored session if necessary.
  if (action.type === LOGGED_IN || !getCurrentUserId()) {
    pd.getMe()
      .then(user => {
        identifyFromUser(user);
      })
      .catch(() => { });
  }
};
export default middleware;

